import React, { useEffect } from "react";
import NumberFormat from "react-number-format";
import useGetMovie from "../custom-hooks/useGetMovie";
import { moviesGet } from "../constants";
import IconCalendar from "../assets/static/icons/calendar.png";
import IconLike from "../assets/static/icons/like.png";
import IconSmile from "../assets/static/icons/smile.png";
import IconDolar from "../assets/static/icons/dolar.png";
import IconCalculator from "../assets/static/icons/calculator.png";
import Casting from "./Casting";
import Video from "./Video";

import "../assets/styles/components/MovieDetail.scss";
const MovieDetail = (data) => {


  const { movie, getMovie } = useGetMovie(`${moviesGet(data.id)}`);

  useEffect(() => {
    getMovie();
  }, []);

  const {
    id,
    original_title,
    budget,
    revenue,
    release_date,
    overview,
    vote_average,
    popularity,
    poster_path,
    title,
  } = movie;

  const year = new Date(release_date);

  return (
    <div className="characterDetail">
      <div className="characterDetaildetail">
        <img
          className = "character-img"
          src={`https://image.tmdb.org/t/p/w500/${poster_path}`}
          alt="Movie"
        />
      </div>
      <div className="characterDetaildetail">
        <h2>{original_title} </h2>
        <p>{title} </p>
        <p>
          <img
            className="icon-img"
            src={IconCalendar}
            alt="año"
            title="release year"
          />
          <span>{year.getFullYear()}</span>
          <img
            className="icon-img"
            src={IconSmile}
            alt="popularity"
            title="popularity"
          />
          <span>{popularity}</span>
          <img
            className="icon-img"
            src={IconLike}
            alt="votes"
            title="vote average"
          />
          <span>{vote_average}</span>
        </p>
        <p>
          <span>{overview}</span>
        </p>
        <p>
          <img
            className="icon-img"
            src={IconCalculator}
            alt="budget"
            title="budget"
          />
          <span>
            <NumberFormat
              value={budget}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
          </span>
          <img
            className="icon-img"
            src={IconDolar}
            alt="revenue"
            title="revenue"
          />
          <span>
            <NumberFormat
              value={revenue}
              displayType={"text"}
              thousandSeparator={true}
              prefix={"$"}
            />
          </span>
        </p>
      </div>
      <div className="characterDetaildetail">
          <Video key={id} data={id} />
      </div>
      <div>
        <Casting key={id} data={id} />
      </div>
    </div>
  );
};

export default MovieDetail;

